import * as api from '../api';
import * as types from './types';

export const receiveTimeseries = (timeseries, location_id, isp, shard) => {
	return {
		type: types.RECEIVE_TIMESERIES,
		timeseries,
		location_id,
		isp,
		shard
	}
}

export const timeseriesLoadingError = (location_id, isp, shard) => {
	return {
		type: types.TIMESERIES_LOADING_ERROR,
		location_id,
		isp,
		shard
	}
}

export const setTimeseriesLoading = (location_id, isp, shard) => {
	return {
		type: types.SET_TIMESERIES_LOADING,
		location_id,
		isp,
		shard
	}
}

export const fetchTimeseries = (location_id, isp, shard) => {
	return async (dispatch, getState) => {
    dispatch(setTimeseriesLoading(location_id, isp, shard))
		let data
		try {
			data = await api.fetchTimeseries(location_id, isp, shard)
		} catch(e) {
			dispatch(timeseriesLoadingError(location_id, isp, shard))
		}
		dispatch(receiveTimeseries(data, location_id, isp, shard))
	}
}



// WEBPACK FOOTER //
// ./src/actions/timeseries.js